export const LESSONS = [
  "Rarible-Basics-Lesson-I-bfe3c03f45214129b1cf3a2f72480687",
  "Rarible-Basics-Lesson-II-50d2c025e742429ca59ce84e4c2eb75d",
  "Rarible-Basics-Lesson-III-10a202ea7c6c4ee2a544f9b9fb258652",
  "Rarible-Basics-Lesson-IV-5ad87b6a548349c7b407c7f14e4dde87",
];

export const NOTION_API_URL = "https://notion-api.splitbee.io/v1/page";
